import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, mergeProps as _mergeProps, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "login-wrapper"
};
const _hoisted_2 = { class: "animate login-form clearfix" };
const _hoisted_3 = { class: "form-container clearfix" };
const _hoisted_4 = { class: "form-body clearfix bg-white" };
const _hoisted_5 = {
    key: 0,
    class: "clearfix"
};
const _hoisted_6 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_7 = { class: "invalid-feedback" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_9 = { class: "invalid-feedback" };
const _hoisted_10 = { class: "col-xs-12 col-sm-12" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12 top20" };
const _hoisted_12 = { class: "float-start top5" };
const _hoisted_13 = {
    key: 1,
    class: "col-xs-12 col-sm-12"
};
const _hoisted_14 = { class: "float-end" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b, _c, _d;
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_PasswordLegendVue = _resolveComponent("PasswordLegendVue");
    const _component_b_alert = _resolveComponent("b-alert");
    const _component_router_link = _resolveComponent("router-link");
    const _component_b_button = _resolveComponent("b-button");
    return (_ctx.attemptedTokenValidation)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _cache[19] || (_cache[19] = _createStaticVNode("<div class=\"form-header dark clearfix\"><div class=\"float-start\"><i class=\"fa-stack fa-lg fa-2x white-text\"><i class=\"fa fa-circle fa-stack-2x\"></i> <i class=\"fa fa-unlock-alt fa-stack-1x fa-inverse dark-blue-text\"></i></i> <h1 class=\"content-title hidden-xs\">\r\n\t\t\t\t\t\t\tChange your password\r\n\t\t\t\t\t\t</h1></div></div> ", 2)),
                    _createElementVNode("div", _hoisted_4, [
                        (_ctx.tokenIsValid)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _cache[2] || (_cache[2] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\tPassword *\r\n\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                    _cache[3] || (_cache[3] = _createTextVNode()),
                                    _createVNode(_component_b_form_input, _mergeProps(_ctx.passwordVal, {
                                        type: "password",
                                        modelValue: _ctx.password,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.password) = $event)),
                                        name: "password",
                                        class: { 'is-invalid': ((_a = _ctx.errors) === null || _a === void 0 ? void 0 : _a.password) && !_ctx.passwordChanged },
                                        ref: "password",
                                        onKeyup: _withKeys(_ctx.changePassword, ["enter"]),
                                        disabled: _ctx.passwordChanged,
                                        autocomplete: "new-password"
                                    }), null, 16 /* FULL_PROPS */, ["modelValue", "class", "onKeyup", "disabled"]),
                                    _cache[4] || (_cache[4] = _createTextVNode()),
                                    _withDirectives(_createElementVNode("div", _hoisted_7, "\r\n\t\t\t\t\t\t\t\t* Please enter a valid password\r\n\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                        [_vShow, ((_b = _ctx.errors) === null || _b === void 0 ? void 0 : _b.password) && !_ctx.passwordChanged]
                                    ]),
                                    _cache[5] || (_cache[5] = _createTextVNode()),
                                    _createVNode(_component_PasswordLegendVue)
                                ]),
                                _cache[12] || (_cache[12] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_8, [
                                    _cache[6] || (_cache[6] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\tConfirm Password *\r\n\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                    _cache[7] || (_cache[7] = _createTextVNode()),
                                    _createVNode(_component_b_form_input, _mergeProps(_ctx.passwordConfirmationVal, {
                                        type: "password",
                                        modelValue: _ctx.passwordConfirmation,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.passwordConfirmation) = $event)),
                                        name: "confirmationPassword",
                                        class: { 'is-invalid': ((_c = _ctx.errors) === null || _c === void 0 ? void 0 : _c.passwordConfirmation) && !_ctx.passwordChanged },
                                        onKeyup: _withKeys(_ctx.changePassword, ["enter"]),
                                        disabled: _ctx.passwordChanged,
                                        autocomplete: "new-password"
                                    }), null, 16 /* FULL_PROPS */, ["modelValue", "class", "onKeyup", "disabled"]),
                                    _cache[8] || (_cache[8] = _createTextVNode()),
                                    _withDirectives(_createElementVNode("div", _hoisted_9, "\r\n\t\t\t\t\t\t\t\t* The confirmation password does not match with the password\r\n\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                        [_vShow, ((_d = _ctx.errors) === null || _d === void 0 ? void 0 : _d.passwordConfirmation) && !_ctx.passwordChanged]
                                    ])
                                ]),
                                _cache[13] || (_cache[13] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_10, [
                                    _createVNode(_component_b_alert, {
                                        show: "",
                                        variant: "primary"
                                    }, {
                                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                                _createTextVNode("\r\n\t\t\t\t\t\t\t\t* Minimum password length is 7 characters. Please use a mix of letters and numbers, as well as upper and lower-case characters.\r\n\t\t\t\t\t\t\t", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _cache[14] || (_cache[14] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                        _createVNode(_component_router_link, {
                                            to: { name: 'login' },
                                            class: "blue float-end"
                                        }, {
                                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tReturn to login page\r\n\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    _cache[11] || (_cache[11] = _createTextVNode()),
                                    _createVNode(_component_b_button, {
                                        type: "button",
                                        class: "float-end",
                                        variant: "outline-secondary",
                                        onClick: _ctx.changePassword,
                                        disabled: _ctx.passwordChanged
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.statusText), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["onClick", "disabled"])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true),
                        _cache[18] || (_cache[18] = _createTextVNode()),
                        (!_ctx.tokenIsValid)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createVNode(_component_b_alert, {
                                    show: "",
                                    variant: "warning"
                                }, {
                                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\tWe are unable to locate your password change request. Please make sure that your request has not expired.\r\n\t\t\t\t\t\t", -1 /* CACHED */)
                                        ]))]),
                                    _: 1 /* STABLE */
                                }),
                                _cache[17] || (_cache[17] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_14, [
                                    _createVNode(_component_router_link, {
                                        to: { name: 'forgotten-password' },
                                        class: "blue lead"
                                    }, {
                                        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                                _createTextVNode("\r\n\t\t\t\t\t\t\t\tWould you like to try again?\r\n\t\t\t\t\t\t\t", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    })
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ])
            ])
        ]))
        : _createCommentVNode("v-if", true);
}
